import { useQuery } from '@hooks/reactQuery';

import { getCcDates } from '@api/configurationComparison';

import { extractQueryParams } from '@utils/common';
import { currentTimeZoneInMinutes } from '@utils/timeUtils';

import { TCMDefaultDTO } from '@interfaces/cmModule/dto/cmModuleDTO';

import { refetchOptions } from '@constants/common';
import { CC_DATES } from '@constants/queryKeys';

export const useQueryCcDates = (params?: TCMDefaultDTO) => {
	const {
		nodeType,
		technology,
		vendor,
		siteIds = [],
	} = params || {};

	const {
		data: datesOptions,
		isFetching: isFetchingDatesOptions,
		isLoading: isLoadingDatesOptions,
	} = useQuery({
		queryKey: [
			CC_DATES,
			{
				vendor,
				technology,
				nodeType,
				siteIds,
				timeZoneMinutes: currentTimeZoneInMinutes,
			},
		],
		queryFn: extractQueryParams(getCcDates),
		enabled: [!!siteIds.length, !!nodeType, !!technology, !!vendor],
		...refetchOptions,
	});

	return {
		datesOptions: datesOptions || [],
		isLoadingDatesOptions: isLoadingDatesOptions && isFetchingDatesOptions,
	};
};
